// extracted by mini-css-extract-plugin
export var colored = "schedule-module--colored--ee17b";
export var event = "schedule-module--event--42103";
export var right = "schedule-module--right--e0dd5";